(function(jQuery, Drupal) {
  'use strict';
  Drupal.behaviors.contactPage = {
    attach: function(context, settings) {
      let winResizeBounce;

      const contactColumns = function() {
        const $row = jQuery('.contact-form-row');
        if (window.innerWidth < 768) {
          $row.prepend($row.find('.right-column'));
        }
        else {
          $row.append($row.find('.right-column'));
        }
      };

      // put together link on click
      jQuery('.email-link-obf').unbind().click(function(e) {
        const $link = jQuery(this);
        let href = $link.attr('href');
        const domain = $link.attr('data-domain');
        $link.attr('href', href + '@' + domain);
      });

      jQuery(window).resize(function() {
        winResizeBounce = setTimeout(function() {
          clearTimeout(winResizeBounce);
          contactColumns();
        }, 100);
      });

      jQuery(document).ready(function() {
        contactColumns();
      });
    }
  };
})(jQuery, Drupal);
